type RewardOutcomeNoticeProps = {
  title: string;
  description: string;
  direction: "ltr" | "rtl";
  titleId?: string;
};

/**
 * Provides a concise, screen-reader-friendly explanation for a confirmed reward result.
 *
 * @example
 * <RewardOutcomeNotice
 *   direction="ltr"
 *   title="Reward confirmed"
 *   description="Your account was updated: +20 XP."
 * />
 */
export function RewardOutcomeNotice({
  title,
  description,
  direction,
  titleId,
}: RewardOutcomeNoticeProps) {
  return (
    <div dir={direction}>
      <p className="font-bold" id={titleId}>
        {title}
      </p>
      <p className="mt-1 text-sm">{description}</p>
    </div>
  );
}
